import React from 'react';
import { FiCalendar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { REPORT_MODES, formatDate } from '../reportUtils';

const ReportToolbar = ({ mode, onModeChange, anchorDate, onAnchorDateChange, onMove,
  periodTitle, classes, classCode, onClassChange }) => (
  <>
    <div className="lms-report__class-row">
      <label htmlFor="lms-report-class">수강 강좌</label>
      <select id="lms-report-class" value={classCode} onChange={(event) => onClassChange(event.target.value)}>
        {classes.map((item) => (
          <option key={item.clClassCode} value={item.clClassCode}>{item.clClassName}</option>
        ))}
      </select>
    </div>

    <nav className="lms-report__tabs" aria-label="학습 리포트 조회 기간">
      {REPORT_MODES.map((item) => (
        <button key={item.value} type="button" className={mode === item.value ? 'is-active' : ''}
          onClick={() => onModeChange(item.value)}>
          {item.label}
        </button>
      ))}
    </nav>

    <div className="lms-report__period-nav">
      <button type="button" onClick={() => onMove(-1)} aria-label="이전 기간"><FiChevronLeft /></button>
      <label className="lms-report__period-title">
        <FiCalendar /><span>{periodTitle}</span>
        <input type="date" value={formatDate(anchorDate)}
          onChange={(event) => onAnchorDateChange(event.target.value)} aria-label="기준 날짜 변경" />
      </label>
      <button type="button" onClick={() => onMove(1)} aria-label="다음 기간"><FiChevronRight /></button>
    </div>
  </>
);

export default ReportToolbar;

